<template>
  <div class="min-h-screen flex flex-col">
    <header class="w-full">
      <nav class="fixed top-0 left-0 right-0 z-50 bg-transparent dark:bg-surface-900">
        <Navbar />
        <div v-if="$slots.subheader" class="relative">
          <div class="absolute inset-0 -z-10 bg-linear-to-b from-gray-600/30 to-transparent" />
          <slot name="subheader" />
        </div>
      </nav>
    </header>
    <div class="mt-16 flex-1 flex flex-col">
      <OutboundLimitNotice />
      <slot />
    </div>
    <AppFooter />
  </div>
  <Toast />
  <ConfirmDialog />
  <ReleaseNotesDialog />
</template>

<script setup>
import Navbar from '../components/Navbar.vue'
import AppFooter from '../components/AppFooter.vue'
import ReleaseNotesDialog from '../components/ReleaseNotesDialog.vue'
import OutboundLimitNotice from '../components/OutboundLimitNotice.vue'
</script>
